import { keepPreviousData, useQuery } from "@tanstack/react-query";
import type { SearchType } from "src/api/search";
import { useDebounce } from "src/hooks/useDebounce";
import { buildQuery } from "src/newApi";

import options from "./defaultOptions";

export type CountDraft = (draft: Record<string, unknown>) => Promise<number>;

// Liczba wyników dla szkicu filtrów w drawerze — na przycisk „Pokaż wyniki”.
// null = drawer zamknięty; poprzednia liczba zostaje w trakcie doczytywania, żeby przycisk nie migał.
// Debounce 500ms — seria kliknięć (np. kilka terminów) to jeden request.
export function useSearchDraftCount(
	type: SearchType,
	currentDraft: Record<string, unknown> | null,
	countDraft?: CountDraft,
) {
	const draft: Record<string, unknown> | null = useDebounce(currentDraft, 500);

	return useQuery<number>({
		queryKey: [
			"search-draft-count",
			type,
			draft && buildQuery(draft),
			draft?.commentsNotifications,
		],

		queryFn: () => countDraft?.(draft ?? {}) ?? Promise.resolve(0),
		...options,
		placeholderData: keepPreviousData,
		enabled: !!draft && !!countDraft,
	});
}
